import config from '../Configs';
export const TriggersEnum = {
    PageOpenTrigger: 'PageOpenTrigger',
    EnterWebsiteTrigger: 'EnterWebsiteTrigger',
    LoginTrigger: 'LoginTrigger',
    LogoutTrigger: 'LogoutTrigger',
    SignUpTrigger: 'SignUpTrigger'
}
Object.freeze(TriggersEnum);

export const ConditionsEnum = {
    PageURLCondition: 'PageURLCondition',
    DeviceTypeCondition: 'DeviceTypeCondition',
    LocationCondition: 'LocationCondition',
    AuthorizationStatusCondition: 'AuthorizationStatusCondition',
    VerificationStatusCondition: 'VerificationStatusCondition',

}
Object.freeze(ConditionsEnum);
export const ActionsEnum = {
    ShowPopupAction: 'ShowPopupAction',
    NavigateToAction: 'NavigateToAction'
}
Object.freeze(ActionsEnum);

export const VerificationStatusEnum = {
    Mobile: 1,
    Email: 2,
    Document: 3,
    ...(config.NEW_PLAT ? {
        Address: 4,
        Citizenship: 5,
        Physical: 6,
        DOB: 7
    } : {})

}
export const ConditionOperatorsEnum = {
    is: 'is',
    isNot: 'is not',
    contains: 'contains',
    doesNotContain: 'does not contain',
    isGreaterThan: 'is greater than',
    isLessThan: 'is less than',
    in: 'in',
    notIn: 'not in'
}
Object.freeze(ActionsEnum);
